import React, { useState, useEffect } from "react";
import { LeaderboardAdContainer } from "./styles";
import LeaderboardImg from "./leaderboard.png";

const LeaderboardAd = (props) => {
  const { hide } = props;
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setImageLoaded(true);
    img.src = LeaderboardImg;
  }, []);

  if (hide) return null;

  if (!imageLoaded) return null;

  return (
    <LeaderboardAdContainer
      href="https://www.downsizing.com.au/news/1752/truecost-launch-a-new-way-to-downsize-with-confidence"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img 
        src={LeaderboardImg} 
        alt="Leaderboard Ad"
        onLoad={() => setImageLoaded(true)}
        onError={() => console.error('Failed to load leaderboard image')}
      />
    </LeaderboardAdContainer>
  );
};

export default LeaderboardAd;
